import styled from 'styled-components'
import Media from 'builder/styles/media'

export const TextFieldContainer = styled.div`
  width: 100%;
  ${Media.Phone`
    margin-bottom: 110px;
  `}
`
